var _g, _g2, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompanyIcon = function SvgCompanyIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_2642_70797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6279,
    height: 1.50136,
    transform: "matrix(1 0 -0.042534 0.999095 2.06348 19.5)",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.6279,
    height: 1.50136,
    transform: "matrix(1 0 -0.042534 0.999095 2.06348 19.5)",
    fill: "url(#paint0_linear_2642_70797)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.159578,
    y: 0.166516,
    width: 19.2945,
    height: 1.16803,
    transform: "matrix(1 0 -0.042534 0.999095 2.07056 19.5002)",
    stroke: "url(#paint1_linear_2642_70797)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_2642_70797)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6142 9.2079V4.74319L12.0555 3L15.4968 4.74319V9.18028L16.8726 8.42046L19.1553 9.68084V20.25C14.4052 20.25 9.65512 20.25 4.90527 20.25V9.68084L7.18813 8.42046L8.6142 9.2079ZM11.8675 19.3788V4.0776L9.52096 5.2661V19.3788H11.8675ZM7.19498 19.3788V9.42443L8.56355 10.1801V19.3788H7.19498ZM16.8656 19.3788V9.42443L15.4968 10.1801V19.3788H16.8656Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6142 9.2079V4.74319L12.0555 3L15.4968 4.74319V9.18028L16.8726 8.42046L19.1553 9.68084V20.25C14.4052 20.25 9.65512 20.25 4.90527 20.25V9.68084L7.18813 8.42046L8.6142 9.2079ZM11.8675 19.3788V4.0776L9.52096 5.2661V19.3788H11.8675ZM7.19498 19.3788V9.42443L8.56355 10.1801V19.3788H7.19498ZM16.8656 19.3788V9.42443L15.4968 10.1801V19.3788H16.8656Z",
    fill: "url(#paint2_linear_2642_70797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56586 9.29544L8.7142 9.37735V9.2079V4.80463L12.0555 3.1121L15.3968 4.80463V9.18028V9.34974L15.5451 9.26782L16.8726 8.53469L19.0553 9.73986V20.15H19.0439H19.0161H18.9883H18.9604H18.9326H18.9048H18.8769H18.8491H18.8213H18.7935H18.7656H18.7378H18.71H18.6821H18.6543H18.6265H18.5986H18.5708H18.543H18.5151H18.4873H18.4595H18.4316H18.4038H18.376H18.3481H18.3203H18.2925H18.2646H18.2368H18.209H18.1811H18.1533H18.1255H18.0976H18.0698H18.042H18.0141H17.9863H17.9585H17.9306H17.9028H17.875H17.8471H17.8193H17.7915H17.7636H17.7358H17.708H17.6802H17.6523H17.6245H17.5967H17.5688H17.541H17.5132H17.4853H17.4575H17.4297H17.4018H17.374H17.3462H17.3183H17.2905H17.2627H17.2348H17.207H17.1792H17.1513H17.1235H17.0957H17.0678H17.04H17.0122H16.9843H16.9565H16.9287H16.9008H16.873H16.8452H16.8173H16.7895H16.7617H16.7338H16.706H16.6782H16.6504H16.6225H16.5947H16.5669H16.539H16.5112H16.4834H16.4555H16.4277H16.3999H16.372H16.3442H16.3164H16.2885H16.2607H16.2329H16.205H16.1772H16.1494H16.1215H16.0937H16.0659H16.038H16.0102H15.9824H15.9545H15.9267H15.8989H15.871H15.8432H15.8154H15.7875H15.7597H15.7319H15.704H15.6762H15.6484H15.6206H15.5927H15.5649H15.5371H15.5092H15.4814H15.4536H15.4257H15.3979H15.3701H15.3422H15.3144H15.2866H15.2587H15.2309H15.2031H15.1752H15.1474H15.1196H15.0917H15.0639H15.0361H15.0082H14.9804H14.9526H14.9247H14.8969H14.8691H14.8412H14.8134H14.7856H14.7577H14.7299H14.7021H14.6743H14.6464H14.6186H14.5908H14.5629H14.5351H14.5073H14.4794H14.4516H14.4238H14.3959H14.3681H14.3403H14.3124H14.2846H14.2568H14.2289H14.2011H14.1733H14.1454H14.1176H14.0898H14.0619H14.0341H14.0063H13.9784H13.9506H13.9228H13.8949H13.8671H13.8393H13.8115H13.7836H13.7558H13.728H13.7001H13.6723H13.6445H13.6166H13.5888H13.561H13.5331H13.5053H13.4775H13.4496H13.4218H13.394H13.3661H13.3383H13.3105H13.2826H13.2548H13.227H13.1991H13.1713H13.1435H13.1156H13.0878H13.06H13.0321H13.0043H12.9765H12.9486H12.9208H12.893H12.8652H12.8373H12.8095H12.7817H12.7538H12.726H12.6982H12.6703H12.6425H12.6147H12.5868H12.559H12.5312H12.5033H12.4755H12.4477H12.4198H12.392H12.3642H12.3363H12.3085H12.2807H12.2528H12.225H12.1972H12.1693H12.1415H12.1137H12.0859H12.058H12.0302H12.0024H11.9745H11.9467H11.9189H11.891H11.8632H11.8354H11.8075H11.7797H11.7519H11.724H11.6962H11.6684H11.6405H11.6127H11.5849H11.557H11.5292H11.5014H11.4735H11.4457H11.4179H11.39H11.3622H11.3344H11.3066H11.2787H11.2509H11.2231H11.1952H11.1674H11.1396H11.1117H11.0839H11.0561H11.0282H11.0004H10.9726H10.9447H10.9169H10.8891H10.8612H10.8334H10.8056H10.7777H10.7499H10.7221H10.6942H10.6664H10.6386H10.6108H10.5829H10.5551H10.5273H10.4994H10.4716H10.4438H10.4159H10.3881H10.3603H10.3324H10.3046H10.2768H10.2489H10.2211H10.1933H10.1654H10.1376H10.1098H10.0819H10.0541H10.0263H9.99845H9.97062H9.94279H9.91495H9.88712H9.85929H9.83146H9.80363H9.77579H9.74796H9.72013H9.6923H9.66447H9.63663H9.6088H9.58097H9.55314H9.52531H9.49748H9.46964H9.44181H9.41398H9.38615H9.35832H9.33048H9.30265H9.27482H9.24699H9.21916H9.19132H9.16349H9.13566H9.10783H9.08H9.05217H9.02433H8.9965H8.96867H8.94084H8.91301H8.88517H8.85734H8.82951H8.80168H8.77385H8.74602H8.71818H8.69035H8.66252H8.63469H8.60686H8.57903H8.55119H8.52336H8.49553H8.4677H8.43987H8.41203H8.3842H8.35637H8.32854H8.30071H8.27288H8.24504H8.21721H8.18938H8.16155H8.13372H8.10589H8.07805H8.05022H8.02239H7.99456H7.96673H7.9389H7.91106H7.88323H7.8554H7.82757H7.79974H7.77191H7.74408H7.71624H7.68841H7.66058H7.63275H7.60492H7.57709H7.54925H7.52142H7.49359H7.46576H7.43793H7.4101H7.38226H7.35443H7.3266H7.29877H7.27094H7.24311H7.21528H7.18744H7.15961H7.13178H7.10395H7.07612H7.04829H7.02045H6.99262H6.96479H6.93696H6.90913H6.8813H6.85347H6.82563H6.7978H6.76997H6.74214H6.71431H6.68648H6.65865H6.63081H6.60298H6.57515H6.54732H6.51949H6.49166H6.46383H6.43599H6.40816H6.38033H6.3525H6.32467H6.29684H6.26901H6.24117H6.21334H6.18551H6.15768H6.12985H6.10202H6.07419H6.04635H6.01852H5.99069H5.96286H5.93503H5.9072H5.87937H5.85154H5.8237H5.79587H5.76804H5.74021H5.71238H5.68455H5.65672H5.62888H5.60105H5.57322H5.54539H5.51756H5.48973H5.4619H5.43407H5.40623H5.3784H5.35057H5.32274H5.29491H5.26708H5.23925H5.21142H5.18359H5.15575H5.12792H5.10009H5.07226H5.04443H5.0166H5.00527V9.73986L7.18813 8.53469L8.56586 9.29544ZM11.8675 19.4788H11.9675V19.3788V4.0776V3.91486L11.8223 3.98839L9.47577 5.17689L9.42096 5.20466V5.2661V19.3788V19.4788H9.52096H11.8675ZM7.09498 19.3788V19.4788H7.19498H8.56355H8.66355V19.3788V10.1801V10.1211L8.61188 10.0925L7.24331 9.33688L7.09498 9.25498V9.42443V19.3788ZM16.8656 19.4788H16.9656V19.3788V9.42443V9.25499L16.8172 9.33688L15.4484 10.0925L15.3968 10.1211V10.1801V19.3788V19.4788H15.4968H16.8656Z",
    stroke: "url(#paint3_linear_2642_70797)",
    strokeOpacity: 0.1,
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_2642_70797",
    x: -3,
    y: 14.5,
    width: 29.6914,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_2642_70797",
    x: 1.90527,
    y: 0,
    width: 20.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2642_70797",
    x1: 0,
    y1: 0,
    x2: 2.04763,
    y2: 6.79728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2642_70797",
    x1: 0.61337,
    y1: 0.0682436,
    x2: 19.6279,
    y2: 0.0682445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2642_70797",
    x1: 4.90527,
    y1: 3,
    x2: 22.0206,
    y2: 6.59008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3864FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2642_70797",
    x1: 5.35059,
    y1: 3.78409,
    x2: 19.1553,
    y2: 3.78409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Company-Icon.38153e15.svg";
export { ForwardRef as ReactComponent };